import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { Restriction } from '@cobu/types';

// A blocked key means the action is disallowed; a missing key means allowed.
const isAllowed = (
  restriction: Restriction | null | undefined,
  key: keyof NonNullable<Restriction['blocked']>
): boolean => !restriction?.blocked?.[key];

export const useResidentRestrictions = () => {
  const restriction = useSelector((state: RootState) => state.settings.restriction);

  return useMemo(
    () => ({
      restricted: restriction?.restricted ?? false,
      canPost: isAllowed(restriction, 'post'),
      canReact: isAllowed(restriction, 'react'),
      canReport: isAllowed(restriction, 'report'),
      canJoinGroup: isAllowed(restriction, 'joinGroup'),
      canCreateEvent: isAllowed(restriction, 'createEvent'),
      canCreateGroup: isAllowed(restriction, 'createGroup'),
    }),
    [restriction]
  );
};
